export const SEEK_INTERVAL = 0.5
